module.exports = __webpack_public_path__ + "static/media/example-iata-image.b55b4d6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/example-iata-image.svg
// module id = 663
// module chunks = 0